// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "container-1-Y2b";
var _3 = "context-1DxWc";
var _4 = "info-1fR68";
var _5 = "warning-1memu";
var _6 = "icon-aah68";
var _7 = "title-mTqq0";
var _8 = "text-1mXKp";
var _9 = "action-1k12l";
export { _1 as "__esModule", _2 as "container", _3 as "context", _4 as "info", _5 as "warning", _6 as "icon", _7 as "title", _8 as "text", _9 as "action" }
export default { "__esModule": _1, "container": _2, "context": _3, "info": _4, "warning": _5, "icon": _6, "title": _7, "text": _8, "action": _9 }
